// extracted by mini-css-extract-plugin
export default {"pageWrap":"te-z","fullWidth":"ue-z","heading":"ve-z","fullBleed":"we-z","hidden":"xe-z"};